import { useEffect } from 'react';

/**
 * Título da aba e meta description de uma página pública; restaura os originais ao sair.
 */
const usePageMeta = (title, description) => {
  useEffect(() => {
    const previousTitle = document.title;
    let meta = document.querySelector('meta[name="description"]');
    const created = !meta;
    if (created) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'description');
      document.head.appendChild(meta);
    }
    const previousDescription = meta.getAttribute('content');

    document.title = title;
    if (description) meta.setAttribute('content', description);

    return () => {
      document.title = previousTitle;
      if (created) meta.remove();
      else if (previousDescription !== null) meta.setAttribute('content', previousDescription);
    };
  }, [title, description]);
};

export default usePageMeta;
